import jump from 'jump.js'

export default holidayGiftGuide21Nav => {
  // Main nav selectors, broken into type - Separated into Desktop and Mobile
  let ggNavByPriceDesktop = document.querySelector('#hgg-21_nav_desktop div[data-gg-choice="price"]')
  let ggNavByGifteeDesktop = document.querySelector('#hgg-21_nav_desktop div[data-gg-choice="giftee"]')
  let ggNavByPriceMobile = document.querySelector('#hgg-21_nav_mobile div[data-gg-choice="price"]')
  let ggNavByGifteeMobile = document.querySelector('#hgg-21_nav_mobile div[data-gg-choice="giftee"]')

  // All subnav selectors, broken into type - Separated into Desktop and Mobile
  let ggNavSubtierByPriceDesktop = document.querySelector('#hgg-21_nav_desktop div[data-gg-subchoice="price"]')
  let ggNavSubtierByGifteeDesktop = document.querySelector('#hgg-21_nav_desktop div[data-gg-subchoice="giftee"]')
  let ggNavSubtierByPriceMobile = document.querySelector('#hgg-21_nav_mobile div[data-gg-subchoice="price"]')
  let ggNavSubtierByGifteeMobile = document.querySelector('#hgg-21_nav_mobile div[data-gg-subchoice="giftee"]')

  // All Nav items, broken into type - Desktop and Mobile
  let ggNavByPriceTiers = document.querySelectorAll('[data-gg-price-tier]')
  let ggNavByGifteeTiers = document.querySelectorAll('[data-gg-giftee-tier]')

  // Sections on Page - Desktop and Mobile
  let ggByPriceSection = document.querySelector('[data-gg-type="sbprice"]')
  let ggByGifteeSection = document.querySelector('[data-gg-type="sbgiftee"]')

  // Shop by Price Desktop click event listener
  ggNavByPriceDesktop.addEventListener('click', () => {
    ggNavByPriceDesktop.classList.add('active')
    ggNavByGifteeDesktop.classList.remove('active')

    ggNavSubtierByPriceDesktop.classList.add('active')
    ggNavSubtierByGifteeDesktop.classList.remove('active')

    ggByPriceSection.classList.add('active')
    ggByGifteeSection.classList.remove('active')

    ggNavByGifteeTiers.forEach(tier => {
      tier.classList.remove('active')
    })

    jump(`#shop-by-price`, { offset: -150, duration: 100 })

    // // Adding in GTM/GA pageview tracking via datalayer
    // window.dataLayer.push({
    //   event: 'pageview',
    //   page: {
    //     path: '/pages/holiday-gift-guide#shop-by-price',
    //     title: 'Holiday Gift Guide - Shop by Price'
    //   }
    // })
  })

  // Shop by Price Mobile click event listener
  ggNavByPriceMobile.addEventListener('click', () => {
    ggNavByPriceMobile.classList.add('active')
    ggNavByGifteeMobile.classList.remove('active')

    ggNavSubtierByPriceMobile.classList.add('active')
    ggNavSubtierByGifteeMobile.classList.remove('active')

    ggByPriceSection.classList.add('active')
    ggByGifteeSection.classList.remove('active')

    ggNavByGifteeTiers.forEach(tier => {
      tier.classList.remove('active')
    })

    jump(`#shop-by-price`, { offset: 0, duration: 100 })

    // // Adding in GTM/GA pageview tracking via datalayer
    // window.dataLayer.push({
    //   event: 'pageview',
    //   page: {
    //     path: '/pages/holiday-gift-guide#shop-by-price',
    //     title: 'Holiday Gift Guide - Shop by Price'
    //   }
    // })
  })

  // Shop by Giftee Desktop click event listener
  ggNavByGifteeDesktop.addEventListener('click', () => {
    ggNavByGifteeDesktop.classList.add('active')
    ggNavByPriceDesktop.classList.remove('active')

    ggNavSubtierByGifteeDesktop.classList.add('active')
    ggNavSubtierByPriceDesktop.classList.remove('active')

    ggByGifteeSection.classList.add('active')
    ggByPriceSection.classList.remove('active')

    ggNavByPriceTiers.forEach(tier => {
      tier.classList.remove('active')
    })

    jump(`#shop-by-giftee`, { offset: -150, duration: 100 })

    // // Adding in GTM/GA pageview tracking via datalayer
    // window.dataLayer.push({
    //   event: 'pageview',
    //   page: {
    //     path: '/pages/holiday-gift-guide#shop-by-giftee',
    //     title: 'Holiday Gift Guide - Shop by Giftee'
    //   }
    // })
  })
  // Shop by Giftee Mobile click event listener
  ggNavByGifteeMobile.addEventListener('click', () => {
    ggNavByGifteeMobile.classList.add('active')
    ggNavByPriceMobile.classList.remove('active')

    ggNavSubtierByGifteeMobile.classList.add('active')
    ggNavSubtierByPriceMobile.classList.remove('active')

    ggByGifteeSection.classList.add('active')
    ggByPriceSection.classList.remove('active')

    ggNavByPriceTiers.forEach(tier => {
      tier.classList.remove('active')
    })

    jump(`#shop-by-giftee`, { offset: 0, duration: 100 })

    // // Adding in GTM/GA pageview tracking via datalayer
    // window.dataLayer.push({
    //   event: 'pageview',
    //   page: {
    //     path: '/pages/holiday-gift-guide#shop-by-giftee',
    //     title: 'Holiday Gift Guide - Shop by Giftee'
    //   }
    // })
  })

  // Shop by Price subtier click event listeners - Desktop and Mobile
  ggNavByPriceTiers.forEach(tier => {
    tier.addEventListener('click', () => {
      ggNavByPriceTiers.forEach(tier => {
        tier.classList.remove('active')
      })
      tier.classList.add('active')

      ggNavByPriceMobile.classList.add('active')
      ggNavByGifteeMobile.classList.remove('active')

      ggNavSubtierByPriceMobile.classList.add('active')
      ggNavSubtierByGifteeMobile.classList.remove('active')

      ggByPriceSection.classList.add('active')
      ggByGifteeSection.classList.remove('active')

      ggNavByGifteeTiers.forEach(tier => {
        tier.classList.remove('active')
      })
    })
  })

  // Shop by Giftee subtier click event listeners - Desktop and Mobile
  ggNavByGifteeTiers.forEach(tier => {
    tier.addEventListener('click', () => {
      ggNavByGifteeTiers.forEach(tier => {
        tier.classList.remove('active')
      })
      tier.classList.add('active')

      ggNavByGifteeMobile.classList.add('active')
      ggNavByPriceMobile.classList.remove('active')

      ggNavSubtierByGifteeMobile.classList.add('active')
      ggNavSubtierByPriceMobile.classList.remove('active')

      ggByGifteeSection.classList.add('active')
      ggByPriceSection.classList.remove('active')

      ggNavByPriceTiers.forEach(tier => {
        tier.classList.remove('active')
      })
    })
  })

  // URL Hashing Logic to allow linking straight to certain tiers
  let urlHash = window.location.hash.split('#')[1]

  // Set up logic for url hash
  if (urlHash) {
    if (urlHash === 'shop-by-price' || urlHash === 'shop-by-price-gifts-under-50' || urlHash === 'shop-by-price-gifts-under-100' || urlHash === 'shop-by-price-gifts-under-200' || urlHash === 'shop-by-price-gifts-under-300') {
      ggNavByPriceDesktop.classList.add('active')
      ggNavByPriceMobile.classList.add('active')
      ggNavSubtierByPriceDesktop.classList.add('active')
      ggNavSubtierByPriceMobile.classList.add('active')

      ggByPriceSection.classList.add('active')
      ggByGifteeSection.classList.remove('active')

      ggNavByGifteeDesktop.classList.remove('active')
      ggNavByGifteeMobile.classList.remove('active')
      ggNavSubtierByGifteeDesktop.classList.remove('active')
      ggNavSubtierByGifteeMobile.classList.remove('active')

      ggNavByPriceTiers.forEach(tier => {
        tier.classList.remove('active')
      })
      ggNavByPriceTiers.forEach(tier => {
        if (tier.dataset.ggPriceTier === urlHash) {
          tier.classList.add('active')
        }
      })
    } else if (urlHash === 'shop-by-giftee' || urlHash === 'shop-by-giftee-the-design-aficionado' || urlHash === 'shop-by-giftee-the-busy-bee' || urlHash === 'shop-by-giftee-the-newly-nested' || urlHash === 'shop-by-giftee-the-forever-cozy' || urlHash === 'shop-by-giftee-the-social-butterfly') {
      ggNavByGifteeDesktop.classList.add('active')
      ggNavByGifteeMobile.classList.add('active')
      ggNavSubtierByGifteeDesktop.classList.add('active')
      ggNavSubtierByGifteeMobile.classList.add('active')

      ggByGifteeSection.classList.add('active')
      ggByPriceSection.classList.remove('active')

      ggNavByPriceDesktop.classList.remove('active')
      ggNavByPriceMobile.classList.remove('active')
      ggNavSubtierByPriceDesktop.classList.remove('active')
      ggNavSubtierByPriceMobile.classList.remove('active')

      ggNavByGifteeTiers.forEach(tier => {
        tier.classList.remove('active')
      })
      ggNavByGifteeTiers.forEach(tier => {
        if (tier.dataset.ggGifteeTier === urlHash) {
          tier.classList.add('active')
        }
      })
    }

    if (window.innerWidth < 769) {
      jump(`#${urlHash}`, { offset: 0, duration: 100 })
    } else {
      jump(`#${urlHash}`, { offset: -200, duration: 100 })
    }
  }
}

// Nav sticky functionality
let hggNav = document.querySelector('#hgg-21_nav')
let origOffsetY = hggNav.offsetTop
let collectionContainer = document.querySelector('.collection-parent-container')
let header = document.querySelector('#header')
let headerHeight = header.offsetHeight
let promoBar = document.querySelector('#shopify-section-announcement-bar')
let promoBarHeight
if (promoBar) {
  promoBarHeight = promoBar.offsetHeight
}

function onScroll (e) {
  if (window.scrollY >= origOffsetY - headerHeight - promoBarHeight) {
    hggNav.classList.add('sticky')
    collectionContainer.classList.add('sticky')
  } else {
    hggNav.classList.remove('sticky')
    collectionContainer.classList.remove('sticky')
  }
}
document.addEventListener('scroll', onScroll)



// WEBPACK FOOTER //
// ./src/scripts/components/holiday-gift-guide-21-nav.js